import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { IChat } from 'src/app/interface/chat';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Push } from 'src/app/helper/push/push-helper';
import { LocalStorage } from 'src/app/class/local-storage';
import { CONSTANTS } from 'src/app/config/constants';
import { Badge } from '@capawesome/capacitor-badge';
import { AnalyticsService } from 'src/app/service/analytics/analytics.service';

@Component({
	selector: 'app-messages-modal',
	templateUrl: './messages-modal.component.html',
	styleUrls: ['./messages-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessagesModalComponent implements OnInit, OnDestroy {

	public chat?: IChat;

	public set unreadMessages(value: number) {
		LocalStorage.set(CONSTANTS.localStorage.keys.menu.unreadMessages, value);
	}
	public get unreadMessages(): number {
		return LocalStorage.get(CONSTANTS.localStorage.keys.menu.unreadMessages);
	}

	constructor(private analyticsService: AnalyticsService) {}

	public ngOnInit(): void {
		this.analyticsService.trackScreen('/modal/messages');
		this.updateBadge();
	}

	public ngOnDestroy(): void {
		this.updateBadge();
	}

	private updateBadge() {
		if (this.unreadMessages) {
			Badge.set({ count: this.unreadMessages });
		} else {
			Badge.clear();
			LocalNotifications.removeAllDeliveredNotifications();
			Push.removeAllDeliveredNotifications();
		}
	}

	public openMessages(chat: IChat) {
		this.chat = chat;
	}

	public messagesDismiss() {
		this.chat = null;
	}
}
